<template>
  <div>

    <!-- Title and search input with button -->
    <div class="mt-[16px] block md:flex justify-between items-center">
      <div class="text-[25px] font-medium mb-5 lg:mb-0 !text-[#35474B]"> {{lang === 'en' ? 'Category' : 'فئة'}} </div>
      <div class="flex justify-end items-center">
        <label>
          <input type="text" v-model="searchKeyword"
                 class="rounded-[16px] px-[20px] sm:min-w-[250px] md:min-w-[367px] h-[50px] outline-0 border border-[#D6E0E2] mr-[2px] shadow-[0_3px_6px_0_#D6E0E2]"
                 required autocomplete="off"/>
        </label>
        <button type="button"
                class="rounded-[16px] bg-white w-[50px] h-[50px] outline-0 border border-[#D6E0E2] flex justify-center items-center shadow-[0_0_12px_0_#D6E0E2]">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-[21.516px] h-[21.512px]" viewBox="0 0 21.516 21.512">
            <g transform="translate(0 -0.035)">
              <path
                  d="M8.66,17.345a8.638,8.638,0,0,0,5.308-1.823l5.724,5.724a1.076,1.076,0,0,0,1.522-1.522L15.49,14a8.655,8.655,0,1,0-6.83,3.345ZM4.061,4.092a6.5,6.5,0,1,1,0,9.2h0a6.48,6.48,0,0,1-.033-9.165l.033-.033Z"
                  fill="#798b97"/>
            </g>
          </svg>
        </button>
      </div>
    </div>

    <!-- Category Swiper -->
    <div class="flex justify-start align-center gap-[5px] mt-[12px] overflow-x-auto scrollbar">
      <template v-if="!loading && categories.length > 0">
        <swiper :key="isShorter" :space-between="5" :autoplay="{ delay: 1500, disableOnInteraction: false }"
                :dir="lang === 'ar' ? 'rtl' : 'ltr'" :speed="1200" :loop="true" :modules="modules"
                :breakpoints="breakpoints" class="w-full">
          <swiper-slide v-for="(el) in categories" :key="el.id">
            <a href="javascript:void(0)"
               class="rounded-[16px] w-[122px] min-w-[122px] h-[121px] min-h-[121px] outline-0 border border-[#D6E0E2] flex justify-center items-end p-[15px] shadow-[0_0_12px_0_#D6E0E2] text-center text-[#798B97] font-bold"
                :class="{'bg-gray-200' : el.active, 'bg-white': !el.active}"
                @click="sentCategoryId(el.id)">
              <span class="truncate-to-2-line" v-if="lang == 'en'"> {{el.name_en}} </span>
              <span class="truncate-to-2-line" v-if="lang == 'ar'"> {{el.name_ar}} </span>
            </a>
          </swiper-slide>
        </swiper>
      </template>
      <template v-if="!loading && categories.length == 0">
        <div class="flex items-center justify-center h-[120px] w-full"> {{lang === 'en' ? 'No categories found' : 'لم يتم العثور على فئات'}}.</div>
      </template>
      <template v-if="loading">
        <LoaderVue/>
      </template>
    </div>

  </div>
</template>

<script>
import {ref, computed} from 'vue';
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/css';
import {Autoplay} from 'swiper/modules';
import LoaderVue from "@/components/Loader.vue";
import ApiService from "@/service/apiService";

export default {
  components: {
    LoaderVue,
    Swiper,
    SwiperSlide,
  },
  props: {
    branchId: {
      required: true
    },
    isShorter: {
      required: true
    },
  },
  watch: {
    branchId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getCategories(newValue);
      }
    }
  },
  data() {
    return {
      lang: window?.core?.lang,
      loading: true,
      breakpoints: ref({
        360: {slidesPerView: 2, spaceBetween: 20},
        460: {slidesPerView: 3, spaceBetween: 20},
        575: {slidesPerView: 4, spaceBetween: 20},
        991: {slidesPerView: 5, spaceBetween: 20},
        1280: {slidesPerView: computed(() => (this.isShorter ? 2 : 5)), spaceBetween: 20},
        1366: {slidesPerView: computed(() => (this.isShorter ? 3 : 6)), spaceBetween: 40},
        1536: {slidesPerView: computed(() => (this.isShorter ? 4 : 6)), spaceBetween: 40},
        1800: {slidesPerView: computed(() => (this.isShorter ? 6 : 10)), spaceBetween: 5}
      }),
      categories: [],
      modules: [Autoplay],
      searchKeyword: '',
    }
  },

  methods: {
    async getCategories(branchId = null) {
      if (this.branchId) {
        const id = branchId ? branchId : this.branchId;
        try {
          this.loading = true;
          const url = `/store/getBranchCat`;
          const response = await ApiService.post(url, {id});
          this.categories = response.data.data;
          this.categories.forEach((each, index) => {
            if(index === 0) {
              each.active = true;
              this.sentCategoryId(each.id);
            } else {
              each.active = false;
            }
          })
        } catch (error) {
          console.error("Error fetching users:", error);
          this.loading = false;
        } finally {
          this.loading = false;
        }
      }
    },

    sentCategoryId(id) {
      this.categories.forEach((each) => {
        if(each.id == id){
          each.active = true;
        }else {
          each.active = false;
        }
      })
      this.$emit('setCategoryId', id);
    },
  },

  mounted() {

  }
};
</script>
